import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

interface ConfirmDeleteModalProps {
  open: boolean;
  // "Comic", "Series" or "Group"
  kind: string;
  name: string;
  // What else happens, e.g. "Its 12 comics will be deleted too."
  detail?: string;
  onClose: () => void;
  onConfirm: () => void;
}

const ConfirmDeleteModal = ({
  open,
  kind,
  name,
  detail,
  onClose,
  onConfirm,
}: ConfirmDeleteModalProps) => (
  <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
    <DialogTitle>Delete {kind}</DialogTitle>

    <DialogContent dividers>
      <Typography>
        Are you sure you want to delete <strong>{name}</strong>?
        {detail && <> {detail}</>}
      </Typography>
    </DialogContent>

    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button variant="contained" color="error" onClick={onConfirm}>
        Delete
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmDeleteModal;
